// components/InitializeToastHelper.tsx
import React, { useEffect } from "react";
import { useToast } from "context/ToastContext";
import { setShowToastFunction } from "./toastHelper";

const InitializeToastHelper: React.FC = () => {
	const { showToast } = useToast();

	useEffect(() => {
		setShowToastFunction(showToast);
	}, [showToast]);

	return null;
};

export default InitializeToastHelper;
